import classNames from "classnames";
import React from "react";

type Props = {
  name: string;
  avatarUrl: string;
  className?: string;
  hideName?: boolean;
};

const SIZE = 20;

const Avatar = ({ name, avatarUrl, className, hideName }: Props) => {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = "//www.gravatar.com/avatar/?d=mp&s=" + SIZE;
    e.currentTarget.onerror = undefined;
  };

  return (
    <span className={className}>
      <img
        src={avatarUrl}
        onError={handleError}
        style={{ width: SIZE, height: SIZE }}
        className={classNames("rounded-full", !hideName && "mr-[5px]")}
        alt={`Avatar for ${name}`}
      />
      {!hideName && <span>{name}</span>}
    </span>
  );
};

export default Avatar;
